module.exports = __webpack_public_path__ + "8a50bfb394e893c320b1e0cbe0da09f2.png";